import { FieldDescriptor } from "./fieldTypes";

/**
 * The catalog **catalog-entry** (`CatalogNodeEntry`) properties panel's field
 * registry — the PLACEMENT of a nested/referenced catalog, distinct from the
 * referenced `Catalog` document itself (`catalogFields.ts`). Checked against a
 * local key list for the same `castable`/`tvMedia` drift documented in
 * `catalogFields.ts`/`catalogPackEntryFields.ts`. Excludes `kind` (fixed
 * `"catalog"`), `url`, and `inline` (edited via the entry panel's own dedicated
 * "remote URL vs. one of my own catalogs" control, not a generic field — `inline`
 * embedding itself is v1, docs/343 §9).
 */
type CatalogNodeEntryFieldKey =
  | "id"
  | "title"
  | "updated"
  | "icon"
  | "placementId"
  | "description"
  | "visibility"
  | "platforms"
  | "castable"
  | "tvMedia"
  | "group"
  | "level"
  | "related"
  | "sameAs";

export const catalogNodeEntryFields = {
  id: { section: "Identity", label: "Entry id", kind: "text" },
  title: { section: "Identity", label: "Title", kind: "text" },
  updated: { section: "Identity", label: "Updated (YYYY-MM-DD)", kind: "text" },
  icon: { section: "Identity", label: "Icon URL", kind: "text" },
  description: { section: "Identity", label: "Description", kind: "textarea" },
  placementId: { section: "Identity", label: "Placement id", kind: "text" },

  group: { section: "Discovery", label: "Group (section label)", kind: "text" },
  level: { section: "Discovery", label: "Level (course number)", kind: "number", integer: true },
  related: { section: "Discovery", label: "Related courses (see-also)", kind: "relatedRefs" },
  sameAs: { section: "Discovery", label: "Same-as key", kind: "text" },

  visibility: {
    section: "Access & capabilities",
    label: "Visibility",
    kind: "select",
    options: [
      { value: "public", label: "public" },
      { value: "private", label: "private" },
      { value: "hidden", label: "hidden" },
    ],
  },
  platforms: { section: "Access & capabilities", label: "Platform availability (opt-out)", kind: "recordBoolean" },
  castable: { section: "Access & capabilities", label: "Castable (AirPlay/Chromecast)", kind: "boolean3" },
  tvMedia: { section: "Access & capabilities", label: "Has TV media (skip-hint)", kind: "boolean3" },
} satisfies Record<CatalogNodeEntryFieldKey, FieldDescriptor>;
